import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { loginSignup_asyncActions } from '../../asyncActions/loginSignup_asynActions';
const useSessionSync = () => {
    const dispatch = useDispatch();
    const currentSessionId = useSelector((state) => state.User.sessionId);
    useEffect(() => {
        const handleStorageChange = (event) => {
            if (event.key === 'sessionId' && event.newValue !== currentSessionId) {
                dispatch(loginSignup_asyncActions.logout());
            }
        };
        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, [currentSessionId, dispatch]);
};
export default useSessionSync;
